<template>
  <Navbar></Navbar>
  <div class="product-detail-page">
    <div class="detail-banner">
      <div class="img-box detail-banner-img"><img src="/assets/product/engine/8P68MYL/8P68MYL.jpg" alt=""></div>
      <div class="detail-banner-r">

        <div class="detail-banner-t2">8P68MYL Motorcycle Powertrain</div>
        <div class="detail-banner-desc">
          A self-developed, world’s only horizontally opposed eight-cylinder & 8DCT motorcycle powertrain;<br />
          The 8-cylinder design achieves full balance of reciprocating inertia forces and moments. With a small firing
          interval (90°), fluctuating excitation is 30% lower than a 4-cylinder engine. Its large displacement (2000cc)
          delivers outstanding performance, strong acceleration, and pronounced thrust;<br />
          Through the driveline system to slow down and increase torque, wheel torque reaches a world-leading 2000
          N·m;<br />
          he transmission is fully electronically controlled for smooth, seamless shifts and a “zero-shock” driving
          experience. It includes a reverse R gear for motorcycle backing, offering a new mode of motorcycle mobility.
        </div>
      </div>
    </div>

    <div class="detail-box">
      <div class="detail-title">Core Specifications</div>
      <div class="detail-utils">
        <div class="detail-utils-item">
          <div class="detail-utils-d">Displacement</div>
          <div class="detail-utils-u">2.0L</div>
        </div>
        <div class="detail-utils-item">
          <div class="detail-utils-d">Maximum Power</div>
          <div class="detail-utils-u">113kW/6500rpm</div>
        </div>
        <div class="detail-utils-item">
          <div class="detail-utils-d">Maximum Torque</div>
          <div class="detail-utils-u">190N·m/4500rpm</div>
        </div>
        <div class="detail-utils-item">
          <div class="detail-utils-d">Transmission</div>
          <div class="detail-utils-u">8DCT</div>
        </div>
        <div class="detail-utils-item">
          <div class="detail-utils-d">Emission Standard</div>
          <div class="detail-utils-u">China 4 / Euro V</div>
        </div>
      </div>
    </div>

    <div class="detail-box">
      <div class="detail-title">Core Technologies</div>

      <div class="detail-four-list">
        <div class="detail-four-item">
          <div class="img-box"><img src="/assets/product/engine/8P68MYL/8P68MYL-1.jpg" alt=""></div>
        </div>
        <div class="detail-four-item">
          <div class="detail-four-title">Intake VVT</div>
          <div class="detail-four-desc">
            This innovative technology for Chinese motorcycle engines increases torque by 8‑19 N·m at 1000‑5000 rpm.
          </div>
        </div>
        <div class="detail-four-item">
          <div class="detail-four-title">Electric Water Pump</div>
          <div class="detail-four-desc">
            The electric water pump provides closed‑loop regulation of coolant flow for rapid warm‑up and stabilization
            of target operating temperature, reducing fuel consumption by approximately 1% and CO₂ emissions by 1.5% to
            3%.
          </div>
        </div>
        <div class="detail-four-item">
          <div class="img-box"><img src="/assets/product/engine/8P68MYL/8P68MYL-2.jpg" alt=""></div>
        </div>
      </div>
    </div>

    <div class="detail-box detail-bottom-bgs">
      <div class="detail-updown-list">
        <div class="detail-updown-item">
          <div class="detail-updown-title">Integrated Starter-Generator</div>
          <div class="detail-updown-desc">
            Saves space and weight. The motor provides 40 N·m of starting torque, enabling reliable cold starts down to
            -20°C.
          </div>
          <div class="img-box"><img src="/assets/product/engine/8P68MYL/8P68MYL-3.jpg" alt=""></div>
        </div>
        <div class="detail-updown-item">
          <div class="detail-updown-title">Cylinder Block (High-Pressure Die Cast)</div>
          <div class="detail-updown-desc">
            Features cylinder bore spray coating, reducing bore temperature by >10°C, friction by 20%, and weight by 67%
            compared to iron liners, while increasing hardness by 97%.
          </div>
          <div class="img-box"><img src="/assets/product/engine/8P68MYL/8P68MYL-4.jpg" alt=""></div>
        </div>
      </div>
    </div>

    <div class="detail-swiper-list detail-box">
      <div class="img-box detail-swiper-right ">
        <img src="/assets/product/engine/8P68MYL/8P68MYL-7.jpg" alt=""></img>
      </div>
      <div class="detail-swiper-left">
        <div>
          <div class="detail-title">
            ISG Damper: An innovative application of a dual-stage spring + rubber damping system.
          </div>
          <div class="detail-desc">
            Provides bidirectional damping tailored to all operating conditions and scenarios, reducing engine torque
            fluctuation and driveline noise.
          </div>
        </div>
      </div>
    </div>

    <div class="detail-swiper-list detail-box ">
      <div class="detail-swiper-left">
        <div class="detail-tabs">
          <div class="detail-tab-item active">
            <div class="detail-tab-title">Cylinder Head Cover with Integrated Oil-Air Separator</div>
            <div class="detail-tab-desc">
              Made of magnesium-aluminum alloy, integrating an oil separation structure to reduce weight and simplify
              layout.
            </div>
          </div>
          <div class="detail-tab-item">
            <div class="detail-tab-title">Lightweight Crankshaft</div>
            <div class="detail-tab-desc">
              A cross-plane inherently balanced crankshaft by inertia force reduces bearing load and suppresses engine
              vibration and noise. Crank web minimum thickness is only 2.5mm with a web width of 15mm. Full nitriding
              process enhances strength.
            </div>
          </div>
        </div>
        <div class="detail-swiper-utils">
          <div class="detail-swiper-util-item">
            <div class="detail-swiper-n">
              2.5mm
            </div>
            <div class="detail-swiper-d">
              Crank web minimum thickness
            </div>
          </div>
          <div class="detail-swiper-util-item">
            <div class="detail-swiper-n">
              15mm
            </div>
            <div class="detail-swiper-d">
              Web width
            </div>
          </div>
        </div>
      </div>
      <div class="detail-swiper-right swiper-container">
        <div class="swiper-wrapper">
          <div class="swiper-slide img-box"><img src="/assets/product/engine/8P68MYL/8P68MYL-6.jpg" alt=""></div>
          <div class="swiper-slide img-box"><img src="/assets/product/engine/8P68MYL/8P68MYL-5.jpg" alt=""></div>
        </div>
      </div>
    </div>


  </div>
  <Footer></Footer>
</template>

<script setup>
import { ref, nextTick, onMounted } from 'vue';
import Navbar from '@/components/Navbar.vue';
import Footer from '@/components/Footer.vue';
import Swiper from 'swiper/bundle';
import 'swiper/swiper-bundle.css';
const swiperInstances = ref({});

onMounted(() => {
  nextTick(() => {
    const swiperContainers = document.querySelectorAll('.swiper-container');

    swiperContainers.forEach((container, index) => {
      const containerKey = `swiper_${index}`;
      container.dataset.swiperKey = containerKey;
      const swiperInstance = new Swiper(container, {
        loop: false,
        slidesPerView: 1,
        spaceBetween: 0,
        speed: 300,
        preventClicks: true,
        effect: 'fade',
      });
      swiperInstances.value[containerKey] = swiperInstance;
    });

    bindTabClickEvent();
  });
});
function bindTabClickEvent() {
  const allSwiperLists = document.querySelectorAll('.detail-swiper-list');

  allSwiperLists.forEach((swiperList) => {
    const tabItems = swiperList.querySelectorAll('.detail-tab-item');
    const targetSwiperContainer = swiperList.querySelector('.swiper-container');

    if (!tabItems.length || !targetSwiperContainer) return;

    const containerKey = targetSwiperContainer.dataset.swiperKey;
    const targetSwiper = swiperInstances.value[containerKey];
    if (!targetSwiper) return;

    const handleTabAction = (tabItem, localTabIndex) => {
      tabItems.forEach(item => item.classList.remove('active'));
      tabItem.classList.add('active');
      targetSwiper.slideTo(localTabIndex, 300, true);
    };
    tabItems.forEach((tabItem, localTabIndex) => {
      const handleTabClickWrapper = () => {
        handleTabAction(tabItem, localTabIndex);
      };
      tabItem.removeEventListener('click', handleTabClickWrapper);
      tabItem.removeEventListener('mouseenter', handleTabClickWrapper);
      tabItem.addEventListener('click', handleTabClickWrapper);
      tabItem.addEventListener('mouseenter', handleTabClickWrapper);
    });
  });
}

</script>

<script>
export const pageConfig = {
  title: '8P68MYL Motorcycle Powertrain - FINEST Website',
  keywords: 'FINEST,Engine,Transmission,Electronics',
  description: 'FINEST Automotive Technology Group Co., Ltd.An auto parts enterprise with core technologies of power system from traditional power to hybrid power and then to pure electric power (including inverters) and automotive intelligent integrated system.FINEST has a complete software and hardware industry chain Provide customers with efficient, energy-saving and environmentally friendly automotive power system and Intelligent driving solutions.',
  outputPath: 'en/engine/8P68MYL.html'

};

import { createApp } from 'vue';
import App from './8P68MYL.vue';
import store from '@/store/index';
import "@/assets/styles/global.scss"
import "@/assets/styles/product-details.scss"

function mountApp() {
  const appNode = document.getElementById('app');
  if (appNode) {
    if (appNode._vueApp) {
      appNode._vueApp.unmount();
      delete appNode._vueApp;
    }
    const app = createApp(App);
    app.use(store);
    appNode._vueApp = app.mount(appNode);
  }
}

// 页面加载完成后挂载
document.addEventListener('DOMContentLoaded', mountApp);

if (module.hot) {
  module.hot.accept('./8P68MYL.vue', () => {
    mountApp();
  });
}
</script>

<style lang="scss" scoped></style>